<div class="index_page_outer">
  <app-breadcrumb-list
    [partsOfUrl]="partsOfUrl"
    [dark_backdrop]="true"
    [transparent]="true"
    [standard_max_width]="true"
  >
  </app-breadcrumb-list>
  <div class="index_content">
    <h1>
      {{ 'PAGES.LOCAL_SERVICES_INDEX.H1_PREFIX' | translate }}
      {{ activeCategoryTitle | titlecase }}
    </h1>

    <div class="list-group">
      @if (loading) {
        <div class="isLoading">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
      } @else {
        @for (service of localServices; track $index) {
          <div class="list-group-item">
            <div class="list-group-item-inner">
              <h5 class="mb-1">
                <a [routerLink]="generateLocalServiceLink(service.slug)">{{
                  service.title
                }}</a>
              </h5>
            </div>
          </div>
        }
      }
    </div>
    <app-lp-footer></app-lp-footer>
  </div>
</div>
